import React, { Component } from 'react';
import {BrowserRouter as Router} from 'react-router-dom';
import * as Constants from '../../common/Global/constants';
import {TableCheckBox,CustomTableRow,AddNewButtonLayout,
    DialogSaveButton,DialogProceedButton,TableRadioButton} from '../../common/Global/globalStyles.style';
import {getLocalStorageVariables,getThemeSettingsVariables,isEmptyVariable,
    isEmptyArray,handleTokenExpiry} from '../../common/Global/commonFunctions';
import RegularDropdown from '../../common/DropdownMenus/RegularDropdown';
import {Accordion, Button, Card, Modal} from 'react-bootstrap';
import FilterDropDown from "../../common/DropdownMenus/FilterDropdown";
import AlertDialog from '../../common/AlertDialog';
import { DatePicker } from 'antd';
import moment from 'moment';

let userDetails = getLocalStorageVariables();
let themeSettings = getThemeSettingsVariables();
const resourceDropdownPlaceholder="Select Employee";

class ReAssignForResponseObservation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            componentDidMountFlag:false,
            datalist:[],
            showLoader:false,

            employeesList:[],
            functionMap:[],

            showAlertDialogInfo:false,
            alertDialogMessageInfo:"",

            showAssignResourcesDialogFlag:false,
            resourceDropdownPlaceholder:"Select Employee",

            filterDataList: [],
            FilterDropDownArr: [],
            FilterPlaceholder: "All",

            assigneResourcesFilterDropDownArr :[],
            assignEmployeeFilterDataList:[],
            assignResourcesPlaceholder:"All",
            activeKey: null,
            activeAssignResourceKey: null,
            headingMap: {}
        }
        this.fields = {};
        userDetails = getLocalStorageVariables();
        themeSettings = getThemeSettingsVariables();
    }

    componentDidMount(){
        this.fields = {
            dataSource: [],
            id: "nodeId",
            text: "reportHeadingText",
            parentID: "parentId",
            child: "newChildren",
            expanded: "isExpanded",
        };
        this.getInitData();
        this.getFunctionTree();
    }

    handleStopPropagation = (e) => {
        e.stopPropagation();
    }

    // Tasks to Assignment Selection
    handleSelectionTask = (e) => {
        e.stopPropagation();
        let isChecked = e.target.checked;
        let indexAndObsId = e.target.name;
        let iapArr = indexAndObsId.split(":-:")
        let index = parseInt(iapArr[0]);
        let observationId = parseInt(iapArr[1]);
        let list = [...this.state.datalist];

        list.forEach(item => {
            // newChildren directly contains observations now
            if (item.newChildren && item.newChildren[index]) {

                if (item.newChildren[index].observationId === observationId) {
                    item.newChildren[index].isSelected = isChecked;
                }

                // Check if ALL observations under heading are selected
                const allSelected =
                    item.newChildren.length > 0 &&
                    item.newChildren.every(obs => obs.isSelected === true);

                // Set flag on heading
                item.isObsSelected = allSelected;
            }
        });

        this.setState({
            datalist:list
        });
    }

    handleSelectionObservations = (e) => {
        e.stopPropagation();
        let isChecked = e.target.checked;
        let reportHeadingId = parseInt(e.target.name);
        let list = [...this.state.datalist];

        list.forEach(parent => {
            if (parent.reportHeadingId === reportHeadingId) {

                // toggle all observations under this heading
                if (!isEmptyArray(parent.observationList)) {
                    parent.observationList.forEach(obs => {
                        if (!obs.disabled) {
                            obs.isSelected = isChecked;
                        }
                    });

                    // update parent checkbox based on enabled observations
                    const enabledObs = parent.observationList.filter(
                        obs => !obs.disabled
                    );

                    parent.isObsSelected =
                        enabledObs.length > 0 &&
                        enabledObs.every(obs => obs.isSelected === true);
                } else {
                    parent.isObsSelected = false;
                }
            }
        })

        this.setState({
            datalist: list
        });
        
    }

    selectAll = () => {
        let list = [...this.state.datalist];
        list.forEach(obsObj => {
            // select heading
            obsObj.isObsSelected = true;

            // select all observations
            if (!isEmptyArray(obsObj.newChildren)) {
                obsObj.newChildren.forEach(obs => {
                    obs.isSelected = true;
                });
            }
        });

        this.setState({
            datalist: list
        });
    }

    unSelectAll = () => {
        let list = [...this.state.datalist];

        list.forEach(obsObj => {
            // unselect heading
            obsObj.isObsSelected = false;

            // unselect all observations
            if (!isEmptyArray(obsObj.newChildren)) {
                obsObj.newChildren.forEach(obs => {
                    obs.isSelected = false;
                });
            }
        });
        this.setState({
            datalist:list
        })
    }

    onClickAddToAssignment = () => {
        let list = [...this.state.datalist];

        list.forEach(obsObj => {
            if (!isEmptyArray(obsObj.newChildren)) {
                obsObj.newChildren.forEach(obs => {
                    if (obs.isSelected) {
                        obs.added = true;
                    }
                });
            }
        });

        this.setState({
            datalist:list
        })
    }

    onClickRemoveFromAssignment = () => {
        let list = [...this.state.datalist];
        list.forEach(obsObj => {
            if (!isEmptyArray(obsObj.newChildren)) {
                obsObj.newChildren.forEach(obs => {
                    if (obs.isSelected) {
                        obs.added = false;
                    }
                });
            }
        });

        this.setState({
            datalist:list
        })
    }

    handleAccordionToggle = (eventKey) => {
        if (this.state.activeKey === eventKey) {
            this.setState({ activeKey: null });
        } else {
            this.setState({ activeKey: eventKey });
        }
    }

    handleAccordionToggleAssignResource = (eventKey) => {
        if (this.state.activeAssignResourceKey === eventKey) {
            this.setState({ activeAssignResourceKey: null });
        } else {
            this.setState({ activeAssignResourceKey: eventKey });
        }
    }

    filterDropDownOnClick = (selectedItem) =>{
        let tempFilterDataList =[];
        let tempFilterDataArray = [...this.state.FilterDropDownArr];

        if(selectedItem.label==="All"){
            this.setState({
                filterDataList:[],
            })
        }else{
            this.state.datalist.forEach((parent)=>{
                // filter by parent heading
                if (parent.heading === selectedItem.label) {
                    tempFilterDataList.push({
                        ...parent
                    });
                }
            })
        }
        tempFilterDataArray.forEach(item => {
            item.isSelected = item.label === selectedItem.label;
        });


        this.setState({
            filterDataList:tempFilterDataList,
            FilterDropDownArr:tempFilterDataArray,
            FilterPlaceholder:selectedItem.label
        })
    }

    handleAlertDialogCloseInfo = () => {
        this.setState({
            showAlertDialogInfo:false,
            alertDialogMessageInfo:""
        })
    }

    resourceDropdownClick = (resource) => {
        let list = [...this.state.datalist];
        let resourceCount = 0;

        list.forEach(item => {
            item.newChildren.forEach(child => {
                if (child.isEmployeeTaskSelected) {
                    child.addedEmployeeToAssignment = true;
                    child.employeeId = resource.employeeId;
                    child.employeeFullName = resource.fullName;
                    child.employeeType = resource.employeeType;
                    resourceCount += 1;
                }
                // Unselect after assigning
                child.isEmployeeTaskSelected = false;
                item.isProcSelectedInResources = false;
            });
        });

        if (resourceCount > 0) {
            this.setState({
                showAlertDialogInfo: true,
                alertDialogMessageInfo: `${resourceCount} observations have been allocated to ${resource.fullName}`,
            });
        }
        this.setState({
            datalist: list,
            resourceCount: resourceCount
        });
    }

    handleSelectionTaskInResourcesDialog = (e) => {
        e.stopPropagation();
        const isChecked = e.target.checked;
        const [index, observationId] = e.target.name.split(":-:");

        const datalist = this.state.datalist.map(item => {
            // Update newChildren
            const updatedNewChildren = item.newChildren.map((child, idx) =>
                String(idx) === String(index) && String(child.observationId) === String(observationId)
                    ? { ...child, isEmployeeTaskSelected: isChecked }
                    : child
            );
            // Check if all are selected
            const allSelected = updatedNewChildren.length > 0 && updatedNewChildren.every(obs => obs.isEmployeeTaskSelected === true);

            return {
                ...item,
                newChildren: updatedNewChildren,
                isProcSelectedInResources: allSelected
            };
        });

        this.setState({ datalist });
    }

    handleSelectionProcessTasksInResourcesDialog = (e) => {
        e.stopPropagation();
        const isChecked = e.target.checked;
        const reportHeadingId = parseInt(e.target.name);

        // Create a new datalist with updated flags
        const datalist = this.state.datalist.map(item => {
            if (item.reportHeadingId === reportHeadingId) {
                return {
                    ...item,
                    isProcSelectedInResources: isChecked,
                    newChildren: item.newChildren.map(child => ({
                        ...child,
                        isProcSelectedInResources: isChecked,
                        isEmployeeTaskSelected: isChecked
                    }))
                };
            }
            return item;
        });

        this.setState({ datalist });
    }

    selectAllTasksResourcesDialog = () => {
        const datalist = this.state.datalist.map(item => ({
                ...item,
                isProcSelectedInResources: true,
                newChildren: item.newChildren.map(child => ({
                    ...child,
                    isProcSelectedInResources: true,
                    isEmployeeTaskSelected: true
                }))
            }));

            this.setState({ datalist });
    }   

    unSelectAllTasksResourcesDialog = () => {
        const datalist = this.state.datalist.map(item => ({
            ...item,
            isProcSelectedInResources: false,
            newChildren: item.newChildren.map(child => ({
                ...child,
                isProcSelectedInResources: false,
                isEmployeeTaskSelected: false
            }))
        }));

        this.setState({ datalist });
    }

    assignResourcesDialogClose = () => {
        this.unSelectAllTasksResourcesDialog();
        this.setState({
            datalist:this.state.oldDataList,
            showAssignResourcesDialogFlag:false,
            activeAssignResourceKey:null
        })
    }

    onClickNextButton = () => {
        let list = [...this.state.datalist];
        this.setState({
            showLoader:true
        })

        let isError = true;

        // validation: at least one observation added
        list.forEach(obsObj => {
            obsObj.newChildren.forEach(obs => {
                if (obs.added) {
                    isError = false;
                }
            });
        });

        let tempFilterArray = [
            {
                label: "All",
                isSelected: true,
            },
        ];

            
        list.forEach(obsObj => {
            const showTasks = obsObj.newChildren.some(obs => obs.added);
            if (showTasks) {
                tempFilterArray.push({
                    label: obsObj.heading,
                    isSelected: false
                });
            }
        });
        let oldDataList = JSON.parse(JSON.stringify(this.state.datalist));
        //now do the validation
        if(isError){
            this.setState({
                showLoader:false,
                showAlertDialogInfo:true,
            	alertDialogMessageInfo:"Please add atleast one observation to the assignment"
            });
        }else{
            this.setState({
                showAssignResourcesDialogFlag:true,
                showLoader:false,
                oldDataList:oldDataList,
                assignEmployeeFilterDataList:[],
                assigneResourcesFilterDropDownArr:tempFilterArray,
                assignResourcesPlaceholder:"All"
            })
        }
    }

    assigneResourceFilterDropDownOnClick = (selectedItem) =>{
        let tempFilterDataList =[];
        let tempFilterDataArray = [...this.state.assigneResourcesFilterDropDownArr];
        if(selectedItem.label==="All"){
            this.setState({
                filterDataList:[],
            })
        }else{
            this.state.datalist.forEach(parent => {
                if (parent.heading === selectedItem.label) {
                    const matchedChildren = parent.newChildren.filter(
                        obs => obs.added === true
                    );

                    if (matchedChildren.length > 0) {
                        tempFilterDataList.push({
                            ...parent,
                            newChildren: matchedChildren
                        });
                    }
                }
            });
        }
        tempFilterDataArray.forEach(item => {
            item.isSelected = item.label === selectedItem.label;
        });
        this.setState({
            assignEmployeeFilterDataList:tempFilterDataList,
            assigneResourcesFilterDropDownArr:tempFilterDataArray,
            assignResourcesPlaceholder:selectedItem.label
        })
    }

    onClickAddResourceToAssignment = () => {
        let list = [...this.state.datalist];
        let isError = false;

        // validate resource assignment
        list.forEach(obsObj => {
            obsObj.newChildren.forEach(obs => {
                if (obs.added && isEmptyVariable(obs.employeeId)) {
                    isError = true;
                }
            });
        });

        if(isError){
            this.setState({
                showAlertDialogInfo:true,
                alertDialogMessageInfo:"Please add resource to all the tasks"
            })
        }else{
            //now parse the array
            let assignmentTasks = []
            list.forEach(obsObj => {
                obsObj.newChildren.forEach(obs => {
                    if (obs.added && !isEmptyVariable(obs.employeeId)) {
                        let obj = {
                            employeeId: obs.employeeId,
                            employeeType: obs.employeeType
                        };

                        if (!isEmptyVariable(obs.observationId)) {
                            obj.observationId = obs.observationId;
                        }

                        assignmentTasks.push(obj);
                    }
                });
            });

            this.setState({
                showNextDateDialog:true,
                assignmentTasks:JSON.stringify(assignmentTasks)
            })
        }
    }

    handleDateDialogClose = () => {
        this.setState({
            showNextDateDialog:false,
            assignmentTasks:[]
        })
    }

    handleClear = () => {
        this.setState({
            deadlineDate:null,
            selectedOption:""
        })
    }

    // if onDateChange already exists, replace it; otherwise add this handler
    onDateChange = (date, dateString) => {
        // when user picks a date, clear radio selection so radios become disabled
        this.setState({
            deadlineDate:isEmptyVariable(date)?null:date.format("YYYY-MM-DD")
        })
    }

    handleCheck = (e) =>{
        let selectedOption = e.target.value;
        let FormErrorsTemp = this.state.formErrors;

        if(this.state.submitClickedAtleastOnce){
            FormErrorsTemp['option'] = "";
        }

        this.setState({
            selectedOption
        })
    }

    getRootLevelFunctions = (functionMapTemp) => {
        let rootFunctionArr = [];
            Object.values(functionMapTemp).map((item) => {
            if (item.level === 0 || item.level === null) {
                rootFunctionArr.push(item);
            }
            });
            return rootFunctionArr;
      };
    
      //No need of return value since the array itself is passed and updated.
      //Javascript maintains single array with pointers. it will not deep copy the array
      addParentIdandHasChildrenFlag = (
        tempArr,
        nodeId,
        level,
        parentHeadingId,
        prefix
      ) => {
        tempArr[nodeId].level = level;
        tempArr[nodeId].parentHeadingId = parentHeadingId;
        if (prefix !== "0") {
          tempArr[nodeId].reportHeadingText =
            prefix + ".\xa0\xa0" + tempArr[nodeId].reportHeadingText;
        }
    
        // add parent Id to all the observations
        let ObsList = tempArr[nodeId].observationList.map((item, index) => {
          item.parentId = parentHeadingId;
          if (prefix === "0") {
            item.reportHeadingText =
              index + 1 + ".\xa0\xa0\xa0\xa0" + item.reportHeadingText;
          } else {
            item.reportHeadingText =
              prefix +
              "." +
              (index + 1) +
              ".\xa0\xa0\xa0\xa0" +
              item.reportHeadingText;
          }
          item.level = level + 1;
          return item;
        });
        tempArr[nodeId].observationList = ObsList;
    
        if (!isEmptyArray(tempArr[nodeId].children)) {
          tempArr[nodeId].children.map((childNode, index) => {
            let newPrefix = prefix === "0" ? index + 1 : prefix + "." + (index + 1);
            this.addParentIdandHasChildrenFlag(
              tempArr,
              childNode.nodeId,
              level + 1,
              nodeId,
              newPrefix
            );
          });
        } else {
          tempArr[nodeId].hasChildren = false;
        }
        tempArr[nodeId].reportHeadingText = tempArr[nodeId].reportHeadingText.split('$_$')[0];
      };
    
      createSyncHRFusionData = (parentId, nodeId, headingMap, isExpanded) => {
        //Now create an object
        let headingObj = headingMap[nodeId];
        if(headingObj){
          headingObj.newChildren = [...headingObj.observationList];
          headingObj.isExpanded = isExpanded;
          headingObj.fontbold = true;
          if (parentId !== nodeId) {
            headingObj.parentId = parentId;
          }
          //now add children recursively
          headingObj.children.map((item) => {
            headingObj.newChildren.push(
              this.createSyncHRFusionData(nodeId, item.nodeId, headingMap, true)
            );
          });
          return headingObj;
        }
      };
    
      updateSyncHRFusionData = (parentId, nodeId, headingMap) => {
        //Now create an object
        let headingObj = headingMap[nodeId];
        headingObj.newChildren = [...headingObj.observationList];
        headingObj.fontbold = true;
        //Check the old function map
        if (!isEmptyVariable(this.state.headingMap[nodeId])) {
          headingObj.isExpanded = this.state.headingMap[nodeId].isExpanded;
          headingMap[nodeId].isExpanded = this.state.headingMap[nodeId].isExpanded;
        }
    
        if (parentId !== nodeId) {
          headingObj.parentId = parentId;
        }
        //now add children recursively
        headingObj.children.map((item) => {
          headingObj.newChildren.push(
            this.updateSyncHRFusionData(nodeId, item.nodeId, headingMap)
          );
        });
        return headingObj;
    };
    
    /*******************API CALLS*******************/
    getInitData = () => {
        Promise.all([
            fetch(Constants.EmployeeOrAuditeeList,{
                method: "POST",
                mode:'cors',
                body: new URLSearchParams({
                    email:userDetails.email,
                    accessToken:userDetails.accessToken,
                    assignmentId:this.props.assignmentId,
                    userType:'ae'
                })
            }),
        ])
        .then(([empAudRes]) => { 
            return Promise.all([empAudRes.json()]) 
        })
        .then(([empAudRes]) => {
            let draftAssignmentAuditeeList = [];
            let clientEmployeeList = [];
            let employeesList = [];
            let empList = [];

            if(handleTokenExpiry(empAudRes.responseCode)) return;
            else if(empAudRes.responseCode === Constants.CODE_SUCCESS){
                draftAssignmentAuditeeList = empAudRes.data.draftAssignmentAuditeeList;
                clientEmployeeList = empAudRes.data.clientEmployeeList;
                const matchingAssignmentUnit = clientEmployeeList.filter(emp => {
                    const unitId = JSON.parse(emp.unit)[0]; 
                    return this.props.unitListId.includes(unitId);
                });

                const otherEmployees = clientEmployeeList.filter(emp => {
                    const unitId = JSON.parse(emp.unit)[0];
                    return !this.props.unitListId.includes(unitId);
                });

                const finalList = [...matchingAssignmentUnit, ...otherEmployees];

                let employees = [...draftAssignmentAuditeeList,...finalList];
                employeesList = employees.map(emp => ({
                    ...emp,
                    userName: `${emp.firstName} ${emp.lastName}`,
                    fullName:`${emp.firstName} ${emp.lastName} (${emp.designation})`
                }));

                empList = employeesList.filter(item => item.employeeEmail !== userDetails.email);
            }else{

            }
            
            this.setState({
                employeesList:empList,
                componentDidMountFlag:true
            })
        })
    }

    handleProceedButtonClick = () => {
        let isError = false;
        if(isEmptyVariable(this.state.deadlineDate) && isEmptyVariable(this.state.selectedOption)){
            isError = true;
        }
        if(isError){
            this.setState({
                errorMsg:"Please select a date",
                showLoader:false
            });

            setTimeout(() => {
                this.setState({
                    formErrors:{},
                });
            },Constants.WRNG_MSG_TIMEOUT);
        }else{
            let deadlineDate = "";
            if(!isEmptyVariable(this.state.selectedOption)){
                const days = parseInt(this.state.selectedOption);
                deadlineDate = moment().add(days + 1, 'days').startOf('day').toISOString();
            }else{
                deadlineDate = moment(this.state.deadlineDate, 'YYYY-MM-DD').startOf('day').toISOString();
            }

            //call the fetch function
            fetch(Constants.ReAssign,
            {
                method: "POST",
                mode:'cors',
                body: new URLSearchParams({
                    email:userDetails.email,
                    accessToken:userDetails.accessToken,
                    aeList:this.state.assignmentTasks,
                    assignmentId:this.props.assignmentId,
                    clientResponseDeadline:deadlineDate
                })
            })
            .then(response => { return response.json(); } )
            .then(data =>
            {
                if(handleTokenExpiry(data.responseCode)) return;
                else if(data.responseCode === Constants.CODE_SUCCESS){
                    this.handleDateDialogClose();
                    this.assignResourcesDialogClose();
                    this.handleClear();
                    this.unSelectAll();
                    this.getFunctionTree();
                }else{
                    this.setState({
                        showAlertDialogInfo:true,
                        alertDialogMessageInfo:data.responseMessage
                    })
                }
            });
        }
    }

    getFunctionTree = () => {
        Promise.all([
            fetch(Constants.GetAuditeeEmployeeDraftReports+"/"+this.props.assignmentId+"/observations", {
                method: "POST",
                mode: "cors",
                body: new URLSearchParams({
                    email: userDetails.email,
                    accessToken: userDetails.accessToken
                }),
            })
        ])
        .then(([response]) => {
            return Promise.all([
                response.json()
            ]);
        })
        .then(([data]) => {
            if(handleTokenExpiry(data.responseCode)) return;
            else if (data.responseCode === Constants.CODE_SUCCESS) {
                let temp = data.data.finalHeadingMapping;
                let rootFunctionArr = this.getRootLevelFunctions(temp);
                let rootNodeId = "";
                rootFunctionArr.map((rootNode) => {
                    rootNodeId = rootNode.nodeId;
                    this.addParentIdandHasChildrenFlag(
                        temp,
                        rootNodeId,
                        1,
                        rootNodeId,
                        "0"
                    );
                });
                let syncFusionData = [];
                //clearAndResetFunctionTree - if it is false, then copy the isShowingChildren param
                //from old state array, this is required because whenever the user adds a new node at the nth level
                //all the nodes are collapsed and shows only first level nodes since the API is called again
                if (
                    !isEmptyArray(Object.keys(this.state.headingMap)) &&
                    !this.state.clearAndResetFunctionTree
                ) {
                    rootFunctionArr.map((rootNode) => {
                        let headingObj = this.updateSyncHRFusionData(
                            rootNode.nodeId,
                            rootNode.nodeId,
                            temp
                        );
                        headingObj.fontbold = true;
                        syncFusionData.push(headingObj);
                    });
                } else {
                    //create datastructure and Expand root level node's children by default
                    rootFunctionArr.map((rootNode) => {
                        let headingObj = this.createSyncHRFusionData(
                            rootNode.nodeId,
                            rootNode.nodeId,
                            temp,
                            true
                        );
                        if(!isEmptyArray(Object.keys(temp))){
                            if (temp[rootNode.nodeId]) {
                                temp[rootNode.nodeId].isExpanded = true;
                            }
                            headingObj.fontbold = true;
                            syncFusionData.push(headingObj);
                        }
                    });
                }
                //set the tree fields
                this.fields = {
                    dataSource: syncFusionData,
                    id: "nodeId",
                    text: "reportHeadingText",
                    parentID: "parentId",
                    child: "newChildren",
                    expanded: "isExpanded",
                };
                let tempFilterArray = [
                    {
                        label: "All",
                        isSelected: true,
                    },
                ];
                let datalist = this.fields.dataSource;
                datalist.map((obsObj)=>{
                    tempFilterArray.push({
                        label:`${obsObj.heading}`,
                        isSelected:false
                    })
                });
                this.setState({
                    headingMap: temp,
                    datalist:datalist,
                    FilterDropDownArr:tempFilterArray,
                })
            } else {
                this.setState({
                    showLoader: false,
                    clearAndResetFunctionTree: false,
                    datalist:[]
                });
            }
        });
    };
    /*******************API CALLS END HERE*******************/

    render() {
        return(
            <Router>
                {
                    this.state.componentDidMountFlag &&
                    <div className="m-t-10">
                        {
                            this.state.showLoader &&
                            <div class="loader"></div>
                        }
                        <div className="prev-next-layout">
                            <div className="flex-center-layout secondary-top-bar">
                                <div className="back-btn-layout" onClick={()=>{
                                    this.unSelectAll();
                                    this.props.handleReAssignForResponseDialogClose(true);
                                }}>
                                <span class="material-icons-outlined">arrow_back_ios</span>
                                </div>
                                <h6>{"Re-Assign For Response"}</h6>
                            </div>
                            <div className="flex-center-layout">
                                <div style={{ marginRight: 10 }}>
                                    <FilterDropDown
                                        placeholder={this.state.FilterPlaceholder}
                                        dropdownArr={this.state.FilterDropDownArr}
                                        onDropDownItemClick={this.filterDropDownOnClick}
                                        themeSettings={themeSettings}
                                        name={"label"}
                                        dropdownWidth="200px"
                                    />
                                </div>
                                <div className="bordered-anchor"
                                style={{marginRight:5}}>
                                    <a onClick={this.unSelectAll} href="javascript:void(0);">
                                        <span class="material-icons-outlined">
                                        check_box_outline_blank
                                        </span>
                                        <p>Unselect All</p>
                                    </a>
                                </div>
                                <div className="bordered-anchor"
                                style={{marginRight:5}}>
                                    <a onClick={this.selectAll} href="javascript:void(0);">
                                        <span class="material-icons-outlined">
                                        check_box
                                        </span>
                                        <p>Select All</p>
                                    </a>
                                </div>
                                <AddNewButtonLayout themeSettings={themeSettings}
                                style={{marginRight:5}}>
                                    <a onClick={this.onClickRemoveFromAssignment} href="javascript:void(0);">
                                        <span className="material-icons">remove_circle_outline</span>
                                        <p>Remove</p>
                                    </a>
                                </AddNewButtonLayout>
                            
                                <AddNewButtonLayout themeSettings={themeSettings}>
                                    <a onClick={this.onClickAddToAssignment} href="javascript:void(0);">
                                        <span className="material-icons">add_circle</span>
                                        <p>Add to Assignment</p>
                                    </a>
                                </AddNewButtonLayout>
                            
                                <AddNewButtonLayout themeSettings={themeSettings} style={{marginLeft:5}}>
                                    <a onClick={this.onClickNextButton} href="javascript:void(0);">
                                        {/* <span className="material-icons">add_circle</span> */}
                                        <p>Next</p>
                                        <span class="material-icons-outlined">arrow_forward_ios</span>
                                    </a>
                                </AddNewButtonLayout>
                            </div>
                        </div>
                        <div className="assign-tasks-layout accordion-layout">
                            {
                                (isEmptyArray(this.state.filterDataList)?this.state.datalist:this.state.filterDataList).map((obsObj,index)=>{
                                        let className;
                                        if (index === 0) {
                                            className = 'card-radius'; // CSS for the first item
                                        } else if (index === ((isEmptyArray(this.state.filterDataList)?
                                            this.state.datalist:this.state.filterDataList).length - 1)) {
                                            className = 'card-last'; // CSS for the last item
                                        } else {
                                            className = 'card-middle'; // CSS for all other items
                                        }
                                        const headerText = `${obsObj.heading}`;
                                        const observationList = obsObj.newChildren || [];
                                        return <div className="process-task-list" key={`${obsObj.reportHeadingId}`}>
                                            <Accordion style={{marginTop:index === 0?15:0}} activeKey={this.state.activeKey}>
                                                <Card className={className}> 
                                                    <Card.Header>
                                                        <Accordion.Toggle
                                                            as={Button}
                                                            variant="link"
                                                            eventKey={obsObj.reportHeadingId}
                                                            onClick={() => this.handleAccordionToggle(obsObj.reportHeadingId)}
                                                        >
                                                            <div className='row align-items-center'>
                                                                <TableCheckBox onClick={this.handleStopPropagation}
                                                                    themeSettings={themeSettings}>
                                                                    <input 
                                                                        type="checkbox"
                                                                        name={obsObj.reportHeadingId}
                                                                        id={obsObj.reportHeadingId}
                                                                        onChange={this.handleSelectionObservations}
                                                                        checked={obsObj.isObsSelected?true:false}
                                                                    />
                                                                    <label for={obsObj.reportHeadingId} 
                                                                    style={{marginLeft:-3}}></label>
                                                                </TableCheckBox>
                                                                <h6 className='col-md-6 text-left'>{headerText}</h6>
                                                                    {
                                                                        observationList.length > 0 &&
                                                                        <h6 className='col-md-2 text-left'>{"Total Task: "+observationList.length}</h6>
                                                                    }
                                                                <h6 className='col-md-3 text-center'>{"Added to Assignment: "+ observationList.filter(item => item.added == true).length}</h6>
                                                            </div>
                                                        </Accordion.Toggle>
                                                    </Card.Header> 
                                                    <Accordion.Collapse eventKey={obsObj.reportHeadingId}>
                                                        <Card.Body>
                                                            {
                                                                !isEmptyArray(observationList) && 
                                                                <div className="common-tab-bg">
                                                                    <div class="common-table" style={{width: "100%", borderRadius: "4px"}}>
                                                                        <div className="table-custom-layout">
                                                                            <div className="table-custom-header">
                                                                                <div className="table-custom-header-row">
                                                                                    <p style={{width:"5%"}}></p>
                                                                                    <p style={{width:"5%",justifyContent:"center"}}>No</p>
                                                                                    <p style={{width:"82%"}}>Observation</p>
                                                                                    {/* <p style={{width:"30%"}}>Employee</p> */}
                                                                                    <p style={{width:"8%"}}>Added</p>
                                                                                </div>
                                                                            </div>
                                                                            
                                                                            <div className="table-custom-body">
                                                                            {
                                                                                !isEmptyArray(observationList) && 
                                                                                observationList.map((item,idx) => {
                                                                                    return <CustomTableRow themeSettings={themeSettings}
                                                                                    className={item.disabled?"row-disable":""}>
                                                                                        <div className="table-cell" style={{width:"5%"}}>
                                                                                            <TableCheckBox onClick={this.handleStopPropagation}
                                                                                                themeSettings={themeSettings}>
                                                                                                <input 
                                                                                                    type="checkbox"
                                                                                                    name={idx+":-:"+item.observationId}
                                                                                                    id={idx+":-:"+item.observationId}
                                                                                                    onChange={this.handleSelectionTask}
                                                                                                    disabled={item.disabled}
                                                                                                    checked={item.isSelected?true:false}
                                                                                                />
                                                                                                <label for={idx+":-:"+item.observationId} 
                                                                                                style={{marginLeft:6}}></label>
                                                                                            </TableCheckBox>
                                                                                        </div>
                                                                                        <p style={{width:"5%",justifyContent:"center"}}>{(idx+1)}</p>
                                                                                        <p style={{width:"82%"}}>
                                                                                            <div className='task-dangerouslysethtml' dangerouslySetInnerHTML={{__html: item.observationHeading}} />
                                                                                        </p>
                                                                                        {/* <p style={{width:"30%"}}>
                                                                                            {isEmptyArray(item.employeeData)?"":
                                                                                                item.employeeData[0]?.employeeDetails?.firstName+" "+item.employeeData[0]?.employeeDetails?.lastName+" ("+item.employeeData[0]?.employeeDetails?.designation+")"
                                                                                            }
                                                                                        </p> */}
                                                                                        <p style={{width:"8%"}}>
                                                                                            {
                                                                                                item.added &&
                                                                                                <span class="material-icons"
                                                                                                style={{color:`rgba(${themeSettings.themeColor.r},${themeSettings.themeColor.g},${themeSettings.themeColor.b},${themeSettings.themeColor.a})`}}>check_circle</span>
                                                                                            }
                                                                                        </p>
                                                                                        
                                                                                    </CustomTableRow>
                                                                                })
                                                                            }
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            }
                                                        </Card.Body>
                                                    </Accordion.Collapse>
                                                </Card>
                                            </Accordion>
                                            {
                                                this.state.componentDidMountFlag && isEmptyArray(obsObj.observationList) &&
                                                <div class="no-items-layout">
                                                    <div class="no-items-card" style={{padding:"10px"}}>
                                                        <h6 style={{margin:0}}>
                                                        {
                                                            Constants.NO_RECORDS_WARNING
                                                        }
                                                        </h6>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    // })
                                })
                            }
                        </div>
                    </div>
                }
                <AlertDialog
                    showAlertDialog={this.state.showAlertDialogInfo}
                    handleAlertDialogClose={this.handleAlertDialogCloseInfo}
                    type={Constants.ALERT_TYPE_ALERT}
                    alertDialogMessage={this.state.alertDialogMessageInfo}
                    proceedBtnClick={this.handleAlertDialogCloseInfo}
                    proceedBtnLabel={Constants.ALERT_TYPE_OKAY_LABEL}
                    themeSettings={themeSettings}
                />
                {this.state.showAssignResourcesDialogFlag &&
                <Modal className="task-select-table-dialog custom-dialog"
                    show={this.state.showAssignResourcesDialogFlag} 
                    backdrop="static">
                    <Modal.Header>
                        <h5>Assign Client</h5>
                        <button 
                            onClick={this.assignResourcesDialogClose}
                            type="button" data-dismiss="modal">
                            <span class="material-icons">close</span>
                        </button>
                    </Modal.Header>
                    <hr />
                    <div className="modal-body">
                        <div className="body-wrapper">
                            <div className="search-addnew-bg" style={{marginTop:0}}>
                                <div className="search-addnew">
                                    <div className="flex-center-layout">
                                        <div style={{ marginRight: 10 }}>
                                            <FilterDropDown
                                                placeholder={this.state.assignResourcesPlaceholder}
                                                dropdownArr={this.state.assigneResourcesFilterDropDownArr}
                                                onDropDownItemClick={this.assigneResourceFilterDropDownOnClick}
                                                themeSettings={themeSettings}
                                                name={"label"}
                                                dropdownWidth="200px"
                                            />
                                        </div>
                                        <div className="bordered-anchor"
                                        style={{marginRight:5}}>
                                            <a onClick={this.unSelectAllTasksResourcesDialog} href="javascript:void(0);">
                                                <span class="material-icons-outlined">
                                                check_box_outline_blank
                                                </span>
                                                <p>Unselect All</p>
                                            </a>
                                        </div>
                                        <div className="bordered-anchor"
                                        style={{marginRight:5}}>
                                            <a onClick={this.selectAllTasksResourcesDialog} href="javascript:void(0);">
                                                <span class="material-icons-outlined">
                                                check_box
                                                </span>
                                                <p>Select All</p>
                                            </a>
                                        </div>
                                        <div style={{width:"300px"}}>
                                            <RegularDropdown 
                                                placeholder={this.state.resourceDropdownPlaceholder}
                                                dropdownArr={this.state.employeesList}
                                                labelParam="fullName"
                                                onDropDownItemClick={this.resourceDropdownClick}
                                                defaultPlaceholderDropDown={resourceDropdownPlaceholder}
                                            />
                                        </div>
                                    </div>
                                    <div>
                                        <DialogSaveButton themeSettings={themeSettings} 
                                        onClick={this.onClickAddResourceToAssignment} type="button" 
                                        className="modal-save m-b-0">Assign</DialogSaveButton>
                                    </div>
                                </div>       
                            </div>
                            <div className="assign-taskresource accordion-layout" style={{position:"relative"}}>
                                {Object.values(isEmptyArray(this.state.assignEmployeeFilterDataList)?this.state.datalist:this.state.assignEmployeeFilterDataList)
                                .map((obsObj,index)=>{
                                    const addedObservations = (obsObj.newChildren || []).filter(
                                        obs => obs.added === true
                                    );
                                    if (addedObservations.length === 0) return null;
                                    let className = 'card-middle';
                                    if (index === 0) className = 'card-radius';
                                    else if (index === (
                                        (isEmptyArray(this.state.assignEmployeeFilterDataList)
                                            ? this.state.datalist
                                            : this.state.assignEmployeeFilterDataList
                                        ).length - 1)
                                    ) className = 'card-last';
                                    // const headerText = `${obsObj.heading}`;
                                    // showTasks=child.added===true;
                                    // if(showTasks){
                                        // return <div className="process-task-list">
                                        //     <Accordion style={{marginTop:index === 0?15:0}} activeKey={this.state.activeAssignResourceKey}>
                                        //         <Card className={className}> 
                                        //             <Card.Header>
                                        //                 <Accordion.Toggle
                                        //                     as={Button}
                                        //                     variant="link"
                                        //                     eventKey={child.reportHeadingId}
                                        //                     onClick={() => this.handleAccordionToggleAssignResource(child.reportHeadingId)}
                                        //                 >
                                        //                     <div className='row align-items-center'>
                                        //                         <TableCheckBox
                                        //                             themeSettings={themeSettings}>
                                        //                             <input 
                                        //                                 type="checkbox"
                                        //                                 name={child.reportHeadingId}
                                        //                                 id={"RES"+child.reportHeadingId}
                                        //                                 onChange={this.handleSelectionProcessTasksInResourcesDialog}
                                        //                                 checked={child.isProcSelectedInResources?true:false}
                                        //                             />
                                        //                             <label for={"RES"+child.reportHeadingId} 
                                        //                             style={{marginLeft:5}}></label>
                                        //                         </TableCheckBox> 
                                        //                         <h6 className='col-md-6 text-left'>{headerText}</h6>
                                        //                         {
                                        //                             obsObj.count > 0 &&
                                        //                             <h6 className='col-md-2 text-left'>{"Total Task: "+child.count}</h6>
                                        //                         }
                                        //                         <h6 className='col-md-3 text-center'>{"Employee Assigned: "+child.observationList.filter(item => item.added == true).length}</h6>
                                        //                     </div>
                                        //                 </Accordion.Toggle>
                                        //             </Card.Header> 
                                        //             <Accordion.Collapse eventKey={child.reportHeadingId}>
                                        //                 <Card.Body>                                            
                                        //                     {
                                        //                         !isEmptyArray(obsObj.observationList) && 
                                        //                         <div className="common-tab-bg">
                                        //                             <div className="common-table" style={{width:"100%"}}>
                                        //                                 <table className="table">
                                        //                                     <thead>
                                        //                                         <tr>
                                        //                                             <th className="text-center" width={"8%"}></th>
                                        //                                             <th className="text-center" width={"5%"}>No.</th>
                                        //                                             <th width={"55%"}>Observations</th>
                                        //                                             <th width={"33%"}>Employees</th>
                                        //                                         </tr>
                                        //                                     </thead>
                                        //                                     <tbody>
                                        //                                     {
                                        //                                         !isEmptyArray(obsObj.observationList) && 
                                        //                                         obsObj.observationList.map((item,idx) => {
                                        //                                             if(item.added){
                                        //                                                 return <tr>
                                        //                                                     <td>
                                        //                                                         <TableCheckBox
                                        //                                                             themeSettings={themeSettings}>
                                        //                                                             <input 
                                        //                                                                 type="checkbox"
                                        //                                                                 name={idx+":-:"+item.observationId}
                                        //                                                                 id={idx+":-:"+"RES"+item.observationId}
                                        //                                                                 onChange={this.handleSelectionTaskInResourcesDialog}
                                        //                                                                 checked={item.isEmployeeTaskSelected?true:false}
                                        //                                                             />
                                        //                                                             <label for={idx+":-:"+"RES"+item.observationId} 
                                        //                                                             style={{marginLeft:6}}></label>
                                        //                                                         </TableCheckBox>
                                        //                                                     </td>
                                        //                                                     <td className="text-center">{(++idx)}</td>
                                        //                                                     <td>
                                        //                                                         <div className="flex-center-layout">
                                        //                                                     <div className='task-dangerouslysethtml' dangerouslySetInnerHTML={{__html: item.observationHeading}} />                                                                                                {
                                        //                                                             item.completionStatus==="Completed" &&
                                        //                                                             <span style={{marginLeft:6,fontSize:18}}
                                        //                                                             className="material-icons">done_all</span>
                                        //                                                         }
                                        //                                                         </div>
                                        //                                                     </td>
                                        //                                                     <td>{isEmptyVariable(item.employeeFullName)?"":item.employeeFullName}</td>
                                        //                                                 </tr>
                                        //                                             }
                                        //                                         })
                                        //                                     }
                                        //                                     </tbody>
                                        //                                 </table>
                                        //                             </div>
                                        //                         </div>
                                        //                     }
                                        //                 </Card.Body>
                                        //             </Accordion.Collapse>
                                        //         </Card>
                                        //     </Accordion>
                                        // </div>
                                    // }
                                    return (
                                        <div className="process-task-list" key={obsObj.reportHeadingId}>
                                            <Accordion
                                                style={{ marginTop: index === 0 ? 15 : 0 }}
                                                activeKey={this.state.activeAssignResourceKey}
                                            >
                                                <Card className={className}>
                                                    <Card.Header>
                                                        <Accordion.Toggle
                                                            as={Button}
                                                            variant="link"
                                                            eventKey={obsObj.reportHeadingId}
                                                            onClick={() =>
                                                                this.handleAccordionToggleAssignResource(obsObj.reportHeadingId)
                                                            }
                                                        >
                                                            <div className="row align-items-center">
                                                                <TableCheckBox themeSettings={themeSettings}>
                                                                    <input
                                                                        type="checkbox"
                                                                        name={obsObj.reportHeadingId}
                                                                        id={`RES${obsObj.reportHeadingId}`}
                                                                        onChange={this.handleSelectionProcessTasksInResourcesDialog}
                                                                        checked={obsObj.isProcSelectedInResources === true}
                                                                    />
                                                                    <label
                                                                        htmlFor={`RES${obsObj.reportHeadingId}`}
                                                                        style={{ marginLeft: 5 }}
                                                                    />
                                                                </TableCheckBox>

                                                                <h6 className="col-md-6 text-left">{obsObj.heading}</h6>
                                                                <h6 className="col-md-2 text-left">
                                                                    {"Total Task: " + addedObservations.length}
                                                                </h6>
                                                                <h6 className="col-md-3 text-center">
                                                                    {"Employee Assigned: " + addedObservations.length}
                                                                </h6>
                                                            </div>
                                                        </Accordion.Toggle>
                                                    </Card.Header>

                                                    <Accordion.Collapse eventKey={obsObj.reportHeadingId}>
                                                        <Card.Body>
                                                            <div className="common-tab-bg">
                                                                <div className="common-table" style={{ width: "100%" }}>
                                                                    <table className="table">
                                                                        <thead>
                                                                            <tr>
                                                                                <th width="8%" />
                                                                                <th width="5%" className="text-center">No.</th>
                                                                                <th width="55%">Observations</th>
                                                                                <th width="32%">Employees</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                        {
                                                                            addedObservations.map((item, idx) => (
                                                                                <tr key={item.observationId}>
                                                                                    <td>
                                                                                        <TableCheckBox themeSettings={themeSettings}>
                                                                                            <input
                                                                                                type="checkbox"
                                                                                                name={`${idx}:-:${item.observationId}`}
                                                                                                id={`RES-${item.observationId}`}
                                                                                                onChange={this.handleSelectionTaskInResourcesDialog}
                                                                                                checked={item.isEmployeeTaskSelected === true}
                                                                                            />
                                                                                            <label
                                                                                                htmlFor={`RES-${item.observationId}`}
                                                                                                style={{ marginLeft: 6 }}
                                                                                            />
                                                                                        </TableCheckBox>
                                                                                    </td>
                                                                                    <td className="text-center">{idx + 1}</td>
                                                                                    <td>
                                                                                        <div className="flex-center-layout">
                                                                                            <div
                                                                                                className="task-dangerouslysethtml"
                                                                                                dangerouslySetInnerHTML={{
                                                                                                    __html: item.observationHeading
                                                                                                }}
                                                                                            />
                                                                                            {
                                                                                                item.completionStatus === "Completed" &&
                                                                                                <span
                                                                                                    style={{ marginLeft: 6, fontSize: 18 }}
                                                                                                    className="material-icons"
                                                                                                >
                                                                                                    done_all
                                                                                                </span>
                                                                                            }
                                                                                        </div>
                                                                                    </td>
                                                                                    <td>
                                                                                        {isEmptyVariable(item.employeeFullName)
                                                                                            ? ""
                                                                                            : item.employeeFullName}
                                                                                    </td>
                                                                                </tr>
                                                                            ))
                                                                        }
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </Card.Body>
                                                    </Accordion.Collapse>
                                                </Card>
                                            </Accordion>
                                        </div>
                                    );
                                })
                            }
                            </div>
                        </div>
                    </div>
                </Modal>
                }
                <Modal className="custom-dialog" show={this.state.showNextDateDialog} backdrop="static">
                    <Modal.Header>
                        <h5>{"Response Deadline Date"}</h5>
                        <button 
                            onClick={this.handleDateDialogClose}
                            type="button" data-dismiss="modal">
                            <span class="material-icons">close</span>
                        </button>
                    </Modal.Header>
                    <div class="modal-body">
                        <div className="addnew-modal-form">
                            <div class="addnew-modal-form-group">
                                <DatePicker
                                    onChange={this.onDateChange}
                                    value={!isEmptyVariable(this.state.deadlineDate)?moment(this.state.deadlineDate):null}
                                    format={"DD/MM/YYYY"}
                                    placeholder="Select Date"
                                    disabledDate={(current) => current.isBefore(moment().subtract(1,"day"))}
                                    // selectedItem={!isEmptyVariable(this.state.deadlineDate)?moment(this.state.deadlineDate):""}
                                    disabled={!isEmptyVariable(this.state.selectedOption)} // disable when radio selected
                                />
                            </div>
                            <div className='addnew-modal-form-group'>
                                <div className="radio-group radio-group-inline">
                                    <div style={{display: "flex", flexDirection: "row", gap: "20px", alignItems: "center"}}>
                                        <TableRadioButton
                                            key={'7'}
                                            style={{marginLeft:0, display:"flex", flexDirection: "column", alignItems: "center"}}
                                            themeSettings={themeSettings}
                                        >
                                            <input 
                                                type="radio"
                                                name={"deadline"+":-:"+"7"}
                                                id={"deadline"+":-:"+"7"}
                                                value={'7'}
                                                onChange={this.handleCheck}
                                                checked={this.state.selectedOption === "7"}
                                                disabled={!isEmptyVariable(this.state.deadlineDate)}
                                            />
                                            <label htmlFor={"deadline"+":-:"+"7"} style={{marginLeft:0}}>7 Days</label>
                                        </TableRadioButton>
                                        <TableRadioButton
                                            key={'10'}
                                            style={{marginLeft:0, display:"flex", flexDirection: "column", alignItems: "center"}}
                                            themeSettings={themeSettings}
                                        >
                                            <input 
                                                type="radio"
                                                name={"deadline"+":-:"+"10"}
                                                id={"deadline"+":-:"+"10"}
                                                value={'10'}
                                                onChange={this.handleCheck}
                                                checked={this.state.selectedOption === "10"}
                                                disabled={!isEmptyVariable(this.state.deadlineDate)}
                                            />
                                            <label htmlFor={"deadline"+":-:"+"10"} style={{marginLeft:0}}>10 Days</label>
                                        </TableRadioButton>
                                        <TableRadioButton
                                            key={'15'}
                                            style={{marginLeft:0, display:"flex", flexDirection: "column", alignItems: "center"}}
                                            themeSettings={themeSettings}
                                        >
                                            <input 
                                                type="radio"
                                                name={"deadline"+":-:"+"15"}
                                                id={"deadline"+":-:"+"15"}
                                                value={'15'}
                                                onChange={this.handleCheck}
                                                checked={this.state.selectedOption === "15"}
                                                disabled={!isEmptyVariable(this.state.deadlineDate)}
                                            />
                                            <label htmlFor={"deadline"+":-:"+"15"} style={{marginLeft:0}}>15 Days</label>
                                        </TableRadioButton>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {
                            this.state.errorMsg &&
                            <span className="cm-error dialog-error">{this.state.errorMsg}</span>
                        }

                        <div class="dialog-btn-layout">
                            <a class="alert-cancel" href="javascript:void(0);"
                                onClick={this.handleDateDialogClose}
                            >Cancel</a>
                            <a class="alert-cancel" href="javascript:void(0);"
                                onClick={this.handleClear}
                                style={{
                                    marginLeft:"10px"
                                }}
                            >Clear</a>
                            <DialogProceedButton
                                themeSettings={themeSettings}
                                class="alert-proceed"
                                href="javascript:void(0);"
                                onClick={this.handleProceedButtonClick}
                                style={{
                                    marginLeft:"10px"
                                }}
                            >
                                {this.state.showLoader ? <div class="loader-btn mt-2"></div> : "Save"}
                            </DialogProceedButton>
                        </div>
                    </div>
                </Modal>
            </Router>
        );
    }
}

export default ReAssignForResponseObservation;